// httpPorts — the Journal slice: one read (`readJournal`, parsed at the
// boundary by journalAdapter) and one command per write intent. Days are the
// reader's local days, so every call that groups by day sends the browser's
// UTC offset.

import { Result } from "@bilda/utils";
import { parseJournalPage, parseSummarizeOutcome } from "../journalAdapter.js";
import { type JournalPorts, periodId } from "../ports/journal.js";
import type { PortResult } from "../ports/result.js";
import { command } from "./shared.js";

const utcOffsetMinutes = (): number => -new Date().getTimezoneOffset();

const done = async (name: string, body: unknown): PortResult<void> => {
    const r = await command(name, body);
    return Result.isErr(r) ? r : Result.ok(undefined);
};

export const journalHttp: JournalPorts = {
    loadJournal: async (scale, from) => {
        const r = await command("readJournal", {
            scale,
            ...(from === null ? {} : { from }),
            utcOffsetMinutes: utcOffsetMinutes(),
        });
        return Result.isErr(r) ? r : parseJournalPage(r.value);
    },
    writeOwnText: (key, text) =>
        done("writeJournalOwnText", { period: periodId(key), markdown: text }),
    eraseOwnText: (key) =>
        done("clearJournalOwnText", { period: periodId(key) }),
    correctAssistantText: (key, markdown) =>
        done("correctJournalSummary", { period: periodId(key), markdown }),
    unlockAssistantText: (key) =>
        done("unlockJournalSummary", { period: periodId(key) }),
    allowAssistantToReadOwn: () => done("allowJournalOwnTextReading", {}),
    disallowAssistantToReadOwn: () => done("disallowJournalOwnTextReading", {}),
    eraseAllOwnTexts: () => done("eraseJournalOwnTexts", {}),
    summarizePeriod: async (key) => {
        const r = await command("summarizeJournalPeriod", {
            period: periodId(key),
            utcOffsetMinutes: utcOffsetMinutes(),
        });
        return Result.isErr(r) ? r : parseSummarizeOutcome(r.value);
    },
};
